import './Description.css';

export const Description = ({details}) => {
    return <p className='description'>{details.development_description}</p>
}